import { ERRORS, ERRORS_MESSAGE } from '../../constants';

export const getInfoByError = (error, isEmptyAccount) => {
  const errorDesc = {
    code: null,
    titleKey: null,
    subTitleKey: null,
    message: 'general',
  };

  if (isEmptyAccount) {
    errorDesc.code = ERRORS.NO_POSTS;
    errorDesc.titleKey = 'widget.empty.editor.p1';
    errorDesc.subTitleKey = 'widget.empty.editor.p2';
    errorDesc.message = 'Looks like this account has no posts';
    return errorDesc;
  }

  errorDesc.code = error.fromCache ? error.originalCode : error.code;

  if (typeof error.message === 'object') error = error.message;

  if (error.message) {
    error.message = error.message.split('+').join(' ');
    if (
      error.message.indexOf(
        'Error validating access token: Session has expired on',
      ) !== -1
    ) {
      error.message =
        'Error validating access token: Session has expired on...';
    }
  }
  const isDeprecatedError =
    error?.message?.includes(ERRORS_MESSAGE.DEPRECATED_API_VERSION_1) ||
    error?.message?.includes(ERRORS_MESSAGE.DEPRECATED_API_VERSION_2) ||
    error?.message?.includes(ERRORS_MESSAGE.DEPRECATED_API_VERSION_3);
  switch (errorDesc.code) {
    case ERRORS.DEPRECATED_API_1:
      if(error.message.includes(ERRORS_MESSAGE.DEPRECATED_API_VERSION_1)){
        errorDesc.titleKey = 'widget.error.deprecatedPersonalAccount.title';
        errorDesc.subTitleKey = 'widget.error.deprecatedPersonalAccount.desc';
        errorDesc.message = ERRORS_MESSAGE.DEPRECATED_API_VERSION_1;
      }
      break;
    case ERRORS.DEPRECATED_API_2:
      if(error.message.includes(ERRORS_MESSAGE.DEPRECATED_API_VERSION_2)){
        errorDesc.titleKey = 'widget.error.deprecatedPersonalAccount.title';
        errorDesc.subTitleKey = 'widget.error.deprecatedPersonalAccount.desc';
        errorDesc.message = ERRORS_MESSAGE.DEPRECATED_API_VERSION_2;
      }
      break;
    case ERRORS.OLD_API:
      errorDesc.titleKey = 'widget.error.oldApi.content';
      errorDesc.subTitleKey = 'widget.error.oldApi.reconnect';
      errorDesc.message = 'user connected with old API';
      break;
    case ERRORS.INVALID_TOKEN:
    case ERRORS.INVALID_TOKEN_2:
    case ERRORS.INVALID_TOKEN_3:
    case ERRORS.DEPRECATED_API_3:
      errorDesc.titleKey = 'widget.error.invalidResponse.apiProfile.title';
      errorDesc.subTitleKey = 'widget.error.invalidResponse.apiProfile.desc';
      errorDesc.message = 'invalid token';
      if (error.message) {
        if (error.message.includes(ERRORS_MESSAGE.PASSWORD_CHANGED)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.passwordChanged.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.passwordChanged.desc';
          errorDesc.message = ERRORS_MESSAGE.PASSWORD_CHANGED;
        } else if (error.message.includes(ERRORS_MESSAGE.SESSION_EXPIRED)) {
          errorDesc.titleKey = 'widget.error.invalidToken.sessionExpired.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.sessionExpired.desc';
          errorDesc.message = ERRORS_MESSAGE.SESSION_EXPIRED;
        } else if (error.message.includes(ERRORS_MESSAGE.NOT_CONFIRMED_USER)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.notConfirmedUser.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notConfirmedUser.desc';
          errorDesc.message = ERRORS_MESSAGE.NOT_CONFIRMED_USER;
        } else if (error.message.includes(ERRORS_MESSAGE.NOT_AUTHORIZED_APP)) {
          errorDesc.titleKey =
            'widget.error.invalidToken.notAuthorizedApp.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notAuthorizedApp.desc';
          errorDesc.message = ERRORS_MESSAGE.NOT_AUTHORIZED_APP;
        } else if (error.message.includes(ERRORS_MESSAGE.NO_PERMISSION)) {
          errorDesc.titleKey = 'widget.error.invalidToken.notPermission.title';
          errorDesc.subTitleKey =
            'widget.error.invalidToken.notPermission.desc';
          errorDesc.message = ERRORS_MESSAGE.NO_PERMISSION;
        } else if (error.message.includes(ERRORS_MESSAGE.INVALID_AUTH)) {
          errorDesc.titleKey = 'widget.error.invalidToken.invalidAuth.title';
          errorDesc.subTitleKey = 'widget.error.invalidToken.invalidAuth.desc';
          errorDesc.message = ERRORS_MESSAGE.INVALID_AUTH;
        } else if (error.fromCache) {
          errorDesc.titleKey = 'widget.error.restoredFromCache.title';
          errorDesc.subTitleKey = 'widget.error.restoredFromCache.desc';
          errorDesc.message = ERRORS_MESSAGE.FETCHED_FROM_CACHE;
        } else if (error.message.includes('You cannot access the app till you log in to www.facebook.com')) {
          errorDesc.titleKey = 'widget.error.invalidToken.notConfirmedUser.title';
          errorDesc.subTitleKey = 'widget.error.invalidToken.notConfirmedUser.desc';
          errorDesc.message = ERRORS_MESSAGE.NOT_CONFIRMED_USER;
        } else if (isDeprecatedError) {
          errorDesc.titleKey = 'widget.error.deprecatedPersonalAccount.title';
          errorDesc.subTitleKey = 'widget.error.deprecatedPersonalAccount.desc';
          errorDesc.message = ERRORS_MESSAGE.DEPRECATED_API_VERSION_1;
        }
      }
      break;
    case ERRORS.NO_POSTS:
      errorDesc.titleKey = 'widget.empty.editor.p1';
      errorDesc.subTitleKey = 'widget.empty.editor.p2';
      errorDesc.message = 'Looks like this account has no posts';
      break;
    default:
      if (error.fromCache) {
        errorDesc.titleKey = 'widget.error.restoredFromCache.title';
        errorDesc.subTitleKey = 'widget.error.restoredFromCache.desc';
        errorDesc.message = 'general ' + ERRORS_MESSAGE.FETCHED_FROM_CACHE;
      } else {
        errorDesc.titleKey = 'widget.error.connectInsta.content.1';
        errorDesc.subTitleKey = 'widget.error.connectInsta.content.2';
      }
      break;
  }

  return errorDesc;
};

export const isConnectionError = (error, isEmptyAccount) => {
  if (isEmptyAccount || !error) return false;

  const errorCode = error.fromCache ? error.originalCode : error.code;

  if (typeof error.message === 'object') error = error.message;

  if (error.message) {
    error.message = error.message.split('+').join(' ');
    if (
      error.message.indexOf(
        'Error validating access token: Session has expired on',
      ) !== -1
    ) {
      error.message =
        'Error validating access token: Session has expired on...';
    }
  }

  const isOldApiError = errorCode == ERRORS.OLD_API;

  const isTokenError =
    errorCode == ERRORS.INVALID_TOKEN ||
    errorCode == ERRORS.INVALID_TOKEN_2 ||
    errorCode == ERRORS.INVALID_TOKEN_3;

  const errors = [
    ERRORS_MESSAGE.PASSWORD_CHANGED,
    ERRORS_MESSAGE.SESSION_EXPIRED,
    ERRORS_MESSAGE.NOT_CONFIRMED_USER,
    ERRORS_MESSAGE.NO_PERMISSION,
    ERRORS_MESSAGE.NOT_AUTHORIZED_APP,
    ERRORS_MESSAGE.INVALID_AUTH,
  ];

  if (
    isOldApiError ||
    (isTokenError &&
      error.message &&
      errors.some((msg) => error.message.includes(msg)))
  ) {
    return true;
  }

  return false;
};
